module.exports = __webpack_public_path__ + "img/024-like.defada72.svg";